
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnow as ObiHeavySnowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow.js';
 
 
 

 
 export const ObiHeavySnow = createComponent({
   react: React,
   tagName: 'obi-heavy-snow',
   elementClass: ObiHeavySnowElement,
   events: {
     
   }
  });
 
 